import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCloudSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.952 18a4.74 4.74 0 01-3.293-1.319A4.424 4.424 0 012.295 13.5c0-1.193.49-2.338 1.364-3.182A4.74 4.74 0 016.952 9c.292-1.313 1.145-2.466 2.372-3.207a5.874 5.874 0 012.005-.749 6.1 6.1 0 012.167.006c.715.132 1.394.39 2 .76.605.37 1.124.845 1.528 1.397.403.553.683 1.172.823 1.823.14.65.138 1.32-.007 1.97h.99c.92 0 1.8.369 2.45 1.025a3.519 3.519 0 011.015 2.475c0 .928-.365 1.819-1.015 2.475A3.447 3.447 0 0118.83 18H6.952z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgCloudSolid as ReactComponent };
